import { toast } from "sonner"
import { ApiError, sanitizeUserFacingMessage } from "@/lib/api"

export type NormalizedError = {
    status?: number
    code?: string
    message: string
    traceId?: string
}

export function normalizeError(error: unknown): NormalizedError {
    // ApiError from our wrappers
    if (error instanceof ApiError) {
        return {
            status: error.status,
            code: error.code,
            traceId: error.traceId,
            message: sanitizeUserFacingMessage(error.message, error.status),
        }
    }
    // Native Response
    if (typeof Response !== "undefined" && error instanceof Response) {
        const status = error.status
        return { status, message: sanitizeUserFacingMessage(error.statusText || "", status) }
    }
    // Generic Error
    if (error instanceof Error) {
        return { message: sanitizeUserFacingMessage(error.message) }
    }
    // Unknown
    return { message: "Произошла ошибка" }
}

export function showErrorToast(error: unknown, opts?: { title?: string; duration?: number }) {
    const n = normalizeError(error)
    const title = opts?.title
    const msg = n.message || "Произошла ошибка"
    if (title) toast.error(`${title}: ${msg}`, { duration: opts?.duration ?? 5000 })
    else toast.error(msg, { duration: opts?.duration ?? 5000 })
}

// Ensures non-OK responses throw sanitized Error; returns the same Response if OK
export async function ensureOk(res: Response): Promise<Response> {
    if (res.ok) return res
    const text = await res.text().catch(() => "")
    const msg = sanitizeUserFacingMessage(text, res.status)
    throw new ApiError(res.status, msg, text)
}


